
import { controls } from "../../controls";
const ms205 = {
  label: "Loan Account",
  pageLabel: "Loan Account",
  starting: true,
  url: "ms205",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Basic Info",
        uid: "create",
        style: { fontFamily: "verdana" }
      },

    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", widths: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch" }),

    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),

    ...controls.magicDateLabel({ tab: "filter", label: "Opening Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "filterOpeningDate", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),

    ...controls.product({ tab: "filter", width: "col-sm-2", sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Loan" }] } }),

    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),


    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),


    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "filter",
      beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Customer Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", width: "col-sm-2", isRequired: true, options: [
        {
          label: "individual",
          value: "individual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ], name: "customer_type"
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", isRequired: true, star: true, default: true, label: "Active", name: "isActive", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Full Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter Name", name: "customer_number_display", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "First Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter First Name", name: "first_name", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Last Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter Last Name", name: "last_name", width: "col-sm-4" }),



  ],
  form: [
    {
      widths: "col-sm-10",
      tab: "create",
      style: { border: 0, paddingTop: 0 },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Personal Info",
          subComponents: [
            ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
            ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
            ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", width: "col-sm-5" }),

            ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
            ...controls.product({ tab: 'create', isReadOnly: 'edit', isRequired: true, }),
            ...controls.showData({ tab: "create", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", label: "Last A/c No.", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", data: "last_accno", name: "last_accno", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", width: "col-sm-1" }),
            ...controls.displayText({ tab: "create", label: "Customer Type", width: "col-sm-2" }),

            {
              inputType: "select",
              tab: "create",
              default: "",
              widths: {
                parent: "col-sm-2",
                children: "col-sm-12"
              },

              options: [
                {
                  label: "individual",
                  value: "individual"
                },
                {
                  label: "internal",
                  value: "internal"
                },
                {
                  label: "Other",
                  value: "other"
                }
              ],
              placeHolder: "Customer Type",
              //   label: "Branch Code",
              name: "customer_type",
              description: "Select Customer Type"
            },
            ...controls.displayText({ width: "col-sm-8" }),

            ...controls.displayText({ tab: "create", label: "Customer Number", width: "col-sm-2" }),
            ...controls.customerNumber({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.checkBox({ tab: "create", isRequired: true, star: true, default: true, label: "Active", name: "isActive", }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", label: "Account No.", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-4", data: "account_number", name: "account_number", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-6" }),
            ...controls.displayText({ tab: "create", label: "Name", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-4", data: "customer_number_display", name: "customer_number_display" }),
            ...controls.displayText({ tab: "create", width: "col-sm-6" }),
            ...controls.displayText({ tab: "create", label: "Address", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-6", data: "address", name: "address", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-4" }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "add2", name: "add2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "pin", name: "pin" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "state", name: "state" }),
            ...controls.displayText({ tab: "create", width: "col-sm-4" }),
            ...controls.displayText({ tab: "create", label: "Phone No:", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", label: "Home No:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "home_no", name: "home_no" }),
            ...controls.displayText({ tab: "create", label: "Office no:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "office_no", name: "office_no" }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", label: "Date Of Birth:", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-2", data: "dob", name: "dob", displaytype: 'date',
              onRender: [
                // // sum last column of the current table
                { f: 'calculateAge', calcType: 'date', inputs: { source: 'pageData.dob', field: 'age' }, resultVar: 'cal_age' },
                { f: 'setParentState', inputs: { dest: "pageData.age", source: 'allResults', field: 'cal_age' }, resultVar: "age" },
              ]
            }),
            ...controls.displayText({ tab: "create", label: "Age:", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-2", data: "age", name: "age",
            }),
            ...controls.displayText({ tab: "create", label: "Gender:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "gender", name: "gender" }),
            ...controls.displayText({ tab: "create", label: "Occupation:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "occupation", name: "occupation" }),
            ...controls.displayText({ tab: "create", label: "Balance:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "cintotbal", name: "cintotbal", displaytype: "currency" }),
            ...controls.displayText({ tab: "create", label: "PAN:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "panid", name: "panid" }),
            ...controls.displayText({ tab: "create", label: "Aadhar UID", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "aadhar_id", name: "aadhar_id" }),
            ...controls.displayText({ tab: "create", label: "Reference by CIN", width: "col-sm-2" }),
            ...controls.customerNumber({ placeHolder: "Reference CIN", name: "referenceCIN", width: "col-sm-3" }),
          ],
        },


        {
          widths: "col-sm-12",
          tab: "create",
          title: "Account Info",
          subComponents: [

            ...controls.displayText({ tab: "create", star: true, label: "Account Type", width: "col-sm-2", star: true }),

            ...controls.AccountType({
              tab: "create", width: "col-sm-2", isRequired: true, parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ],
            }),
            ...controls.showData({
              tab: "create", data: "account_type_display", width: "col-sm-2", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ],
            }),

            // ...controls.checkBox({
            //   tab: "create", label: "senior Citizen", name: "isSeniorCitizen", parents: [
            //     {
            //       name: "customer_number_display",
            //       match: "exist",
            //       show: 'readonly'
            //     }
            //   ], width: "col-sm-3"
            // }),

            ...controls.checkBox({
              tab: "create", label: "Stop Interest Calculation", name: "stopIntCalc", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-3"
            }),

            ...controls.checkBox({
              tab: "create", label: "Allow ABB Transaction", name: "isAllowABBTransaction", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-3"
            }),
            ...controls.displayText({ tab: "create", star: true, label: "Mode Of Operation", width: "col-sm-2" }),
            ...controls.ModeOfOperation({
              tab: "create", isRequired: true, width: "col-sm-2", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.showData({
              tab: "create", data: "mode_of_operation_display", width: "col-sm-2", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.checkBox({
              tab: "create", width: "col-sm-3", label: "Staff Member", name: "isStaffmember", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.checkBox({
              tab: "create", width: "col-sm-3", label: "Want SMS", name: "isWantsms", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.magicDateLabel({ tab: "create", star: true, label: "Account Opening Date", width: "col-sm-2" }),
            ...controls.magicDate({
              isRequired: true, dateType: "ontype", default: "sessiondate", name: "account_opening_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-4"
            }),
            ...controls.checkBox({
              tab: "create", width: "col-sm-3", label: "Additional rate post expiry", name: "afterExpiryRate", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.checkBox({
              tab: "create", width: "col-sm-3", label: "A/c Signature", name: "isAcSignature", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.displayText({ tab: "create", label: "Interest Rate", width: "col-sm-2" }),
            ...controls.text({
              placeHolder: "Interest Rate", name: "interest_rate", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.checkBox({ label: "Change Rate Applicable", name: "chgRateAppli", width: "col-sm-3" }),
            ...controls.checkBox({ label: "Cheque-Book Issued", name: "isChequeBookIssued", width: "col-sm-3" }),
            ...controls.magicDateLabel({ tab: "create", label: "Last Interest Date", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", default: "sessiondate", name: "last_interest_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),


            ...controls.magicDateLabel({ tab: "create", label: "Last Transaction Date", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "last_Transaction_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-1" }),

            ...controls.checkBox({
              tab: "create", width: "col-sm-3", label: "Stop Installment Penal", name: "stopPenal", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),


            ...controls.magicDateLabel({ tab: "create", star: true, label: "Expiry Date", width: "col-sm-2" }),
            ...controls.magicDate({
              isRequired: true, tab: "create", dateType: "ontype", name: "expiry_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.checkBox({ label: "Want Statement by Email", name: "emailStatement", width: "col-sm-3" }),

            ...controls.select({
              tab: "create",
              defaultValue: "",
              width: "col-sm-3",
              parents: [
                {
                  name: "emailStatement",
                  match: "in",
                  value: [true],
                  show: "readonly"
                }
              ], options: [
                {
                  label: "Daily",
                  value: "daily"
                },
                {
                  label: "weekly",
                  value: "weekly"
                },
                {
                  label: "Fortnightly",
                  value: "fortnightly"
                },
                {
                  label: "Monthly",
                  value: "monthly"
                },
                {
                  label: "Quarterly",
                  value: "quarterly"
                },
                {
                  label: "Half Yearly",
                  value: "halfyearly"
                },
                {
                  label: "Yearly",
                  value: "yearly"
                }
              ], name: "daily_weakly",
              // label:"Email Frequency"
            }),

            ...controls.magicDateLabel({ tab: "create", label: "Close Date", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "close_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),




          ]
        }
      ]
    },


    {
      widths: "col-sm-2",
      tab: "create",
      title: "Buttons",
      style: { marginTop: 10 },
      // subComponents: [
      //   ...controls.footerButtonsLoan()
      // ]
    },




    // {
    //   inputType: "handsonTable",
    //   widths: {
    //     parent: "col-sm-12",
    //     children: "col-sm-12"
    //   },
    //   tab: "nominees",
    //   label: "Nominees",
    //   name: "recurringdepositNominees",
    //   description: "none",
    //   tableOptions: {
    //     // validations, basic calculations, colors, date pickers, context menu etc.
    //     HOTheaders: [
    //       "Name",
    //       "Address.",
    //       "Rel Code",
    //       "Relation",
    //       "Birthdate",
    //       "Age",
    //       "Guardian",
    //       "Given Date"
    //     ],
    //     columns: [
    //       {},
    //       {},
    //       {},
    //       {},
    //       { type: "date" },
    //       { type: "numeric" },
    //       {},
    //       { type: "date" }
    //     ],
    //     rowHeaders: false,
    //     // contextMenu: true,
    //     minSpareRows: 4,
    //     stretchH: "last",
    //     // columnSorting: true,
    //     autoWrapRow: true,
    //     maxRows: 100
    //   }
    // },


  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_display",
        width: 150, type: "small"

      },
      {
        Header: "Cust No",
        accessor: "customer_number"
      },
      {
        Header: "CRN",
        accessor: "crno",
      },
      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },

      {
        Header: "Full Name",
        accessor: "customer_number_display"
      },
      {
        Header: "Open Date",
        accessor: "opening_date"
      },
      {
        Header: "Exp Date",
        accessor: "expiry_date"
      },
      // {
      //   Header: "FD Amt",
      //   accessor: ""
      // },
      // {
      //   Header: "Mat Amt",
      //   accessor: ""
      // }
      {
        Header: "Close Date",
        accessor: "closing_date"
      },
      {
        Header: "Modified By",
        accessor: "last_modified_by"
      },
      {
        Header: "Modified Date",
        accessor: "last_modify_date"

      },
      {
        Header: "Modified Time",
        accessor: "last_modify_time",
        show: false
      },
      {
        Header: "Active",
        accessor: "isActive",
        type: "tick"
      },
    ]
  }
};

export default ms205;
